import {Routes} from '@angular/router';
import {authGuard} from '@core/guards/auth.guard';
import {noAuthGuard} from '@core/guards/no-auth.guard';
import {superAdminGuard} from '@core/guards/super-admin.guard';
import {LayoutComponent} from '@layout/layout.component';
import {authRoutes} from '@modules/auth/auth.routes';

export const routes: Routes = [
  {
    path: 'auth',
    children: authRoutes,
    canActivate: [noAuthGuard],
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('@modules/dashboard/dashboard.routes').then(m => m.dashboardRoutes),
      },
      {
        path: 'workspaces',
        loadChildren: () =>
          import('@modules/workspaces/workspaces.routes').then(m => m.workspacesRoutes),
      },
      {
        path: 'super-admins',
        loadChildren: () =>
          import('@modules/super-admins/super-admins.routes').then(m => m.superAdminsRoutes),
        canActivate: [superAdminGuard],
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('@modules/profile/profile.component').then(m => m.ProfileComponent),
      },
      {path: '', redirectTo: 'dashboard', pathMatch: 'full'},
    ],
  },
  {path: '**', redirectTo: 'dashboard'},
];
